import React, { useState } from 'react';
import { IconPlus, IconSearch, IconGrid } from './Icons';
import './Payroll.css';

const SAMPLE_ROWS = [
  { month: 'March-2025', bankAccount: 'Main Bank', status: 'Processed' },
  { month: 'February-2025', bankAccount: 'Main Bank', status: 'Processed' },
  { month: 'February-2025', bankAccount: 'Main Bank', status: 'Draft' },
];

export default function Payroll() {
  const [showGenerateModal, setShowGenerateModal] = useState(false);

  const COLUMNS = [
    { key: 'month', label: 'Month' },
    { key: 'bankAccount', label: 'Bank Account' },
    { key: 'status', label: 'status' },
  ];

  const activeColumnCount = COLUMNS.length + 1; // +1 for actions column

  const handleExportExcel = () => {
    const header = COLUMNS.map((c) => c.label);
    const rows = SAMPLE_ROWS.map((row) => COLUMNS.map((col) => String(row[col.key] ?? '')));
    const csvLines = [header, ...rows].map((cols) =>
      cols
        .map((v) => {
          const s = v == null ? '' : String(v);
          return s.includes('"') || s.includes(',') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(','),
    );
    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'payroll-export.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="payroll-page">
      <div className="payroll-card">
        <div className="payroll-header-row">
          <h1 className="payroll-title">Payroll</h1>
          <div className="payroll-header-actions">
            <button
              type="button"
              className="payroll-header-btn payroll-header-btn-primary"
              onClick={() => setShowGenerateModal(true)}
            >
              <IconPlus />
              Generate Payroll
            </button>
          </div>
        </div>

        <div className="payroll-filters-row">
          <div className="payroll-filters-left">
            <button
              type="button"
              className="payroll-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>
          </div>

          <div className="payroll-filters-right">
            <button type="button" className="payroll-utility-btn" onClick={handleExportExcel} disabled={SAMPLE_ROWS.length === 0}>
              Excel
            </button>
            <div className="payroll-search">
              <input type="text" placeholder="Search" aria-label="Search payroll" />
              <span className="payroll-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="payroll-table-wrapper">
          <table className="payroll-table">
            <thead>
              <tr>
                {COLUMNS.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              {SAMPLE_ROWS.map((row) => (
                <tr key={`${row.month}-${row.status}`}>
                  <td>
                    <a href="#month" className="payroll-link">
                      {row.month}
                    </a>
                  </td>
                  <td>{row.bankAccount}</td>
                  <td>{row.status}</td>
                  <td />
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="payroll-footer-row">
          <div className="payroll-footer-left">
            <select
              className="payroll-page-size"
              defaultValue="10"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span>1-3 / 3</span>
          </div>
          <div className="payroll-footer-right">
            <button
              type="button"
              className="payroll-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="payroll-page-btn payroll-page-btn-active"
              aria-label="Current page"
            >
              1
            </button>
            <button
              type="button"
              className="payroll-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showGenerateModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowGenerateModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Generate Payroll</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowGenerateModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Month</div>
                <input className="estimates-form-input" placeholder="YYYY-MM" />

                <div className="estimates-form-label">Bank Account</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">-</option>
                </select>
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowGenerateModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowGenerateModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

